/* eslint-disable import/no-dynamic-require */
/* eslint-disable @typescript-eslint/no-var-requires */
const { getThemeConfigVars } = require('@edelman/storyblok-ui/src/styles/utils/getThemeConfigVars');

const { availableThemes } = require('./themeloader');

// Bundle all available theme config data
const themeData = availableThemes.reduce((acc, themeName) => {
  const themeConfig = require(`../themes/${themeName}/theme.config`);
  acc[themeName] = getThemeConfigVars(themeConfig);

  return acc;
}, {});

module.exports = {
  themeData,
};
